export const jwtDecode = () => {
    try {
        const token = localStorage.getItem("authToken");
        if (!token) {  // Handle the case where no token exists
            return null; // or redirect, or throw an error, depending on your needs
        }
        const arrayToken = token.split('.');
        return JSON.parse(atob(arrayToken[1]));
    } catch (error) {
        // If Parsing token results in error means token is malformed and user must return to login screen
        console.error("Error decoding token:", error); // Log the error for debugging
        window.location.href = '/login';
        return null; // Return null to prevent further errors
    }
};

export const isTokenExpired = () => {
    return jwtDecode()?.exp < (Date.now() / 1000);
};

export const checkPermission = (permissionName, action, permissions = []) => {
    // Permission format: { "ripening": "ripening.sorting_pending.update" }
    // permissionName = "ripening.sorting_pending", action = "update"
    // → look for value "ripening.sorting_pending.update" in permissions array

 
    if (!permissions || permissions.length === 0) {
        return false;
    }

    const fullPermission = `${permissionName}.${action}`;

    return permissions.some(perm => {
        const permValue = Object.values(perm)[0];
        return permValue === fullPermission;
    });
};

export const getAllowedTabsByRole = (role) => {
    switch (role) {
        case "admin":
            return [
                "Receiving Area",
                "Ripening & Selection Area",
                "Processing & Cooking Area",
                "Packing Area",
            ];
        case "receiving manager":
            return ["Receiving Area"];
        case "ripening & selection manager":
            return ["Ripening & Selection Area"];
        case "processing cooking manager":
            return ["Processing & Cooking Area"];
        case "packing manager":
            return ["Packing Area"];
        default:
            return [];
    }
}
